import { usePublishedBoxStore } from '@/entities/sets/publish';
import { DatePicker, InputChk, TabMenu } from '@/shared/ui';
import { nickPublishStateArr } from '@/shared/utils/publish';
import moment from 'moment';
import { useEffect, useState } from 'react';

interface ByNicknameFilterProps {
    startDate?: Date;
    endDate?: Date;
    dateTab?: string;
    publishState: number[];
    setPublishState: (newList: number[]) => void;
    setStartDate: (newDate: Date | undefined) => void;
    setEndDate: (newDate: Date | undefined) => void;
    setDateTab: (newTab: string | undefined) => void;
}

export const ByNicknameFilter = ({
    startDate,
    endDate,
    dateTab,
    publishState,
    setPublishState,
    setStartDate,
    setEndDate,
    setDateTab,
}: ByNicknameFilterProps) => {
    const currDate = new Date();
    const [first, setFirst] = useState(true);
    const { setSearchPage } = usePublishedBoxStore();

    useEffect(() => {
        onDateButton('3');
    }, []);

    const handleCheckPublishState = (value: number) => {
        if (value == 0) {
            if (publishState.length === nickPublishStateArr.length - 1) {
                setPublishState([]);
            } else {
                setPublishState([2, 3]);
            }
        } else {
            const current = publishState;

            const next = current.includes(value)
                ? current.filter((item) => item !== value)
                : [...current, value];

            setPublishState(next);
        }
        setSearchPage(0);
    };

    const onDateChange = async (date: Date, rangeType: 's' | 'e') => {
        const start = date;
        const end = endDate ? endDate : undefined;
        setDateTab(undefined);

        switch (rangeType) {
            case 's':
                setStartDate(date);

                if (end && end < start) {
                    const newEnd = new Date(start);
                    newEnd.setDate(newEnd.getDate() + 1);
                    setEndDate(newEnd);
                }
                break;
            case 'e':
                setEndDate(date);
                break;
        }
        setSearchPage(0);
    };

    const onDateButton = async (type: string) => {
        setDateTab(type);
        const newStart = new Date();
        const current = new Date();
        if (type === '0') {
            setStartDate(undefined);
            setEndDate(undefined);
        } else {
            if (type === '7') {
                newStart.setDate(newStart.getDate() - Number(type));
                setStartDate(newStart);
                setEndDate(current);
            } else {
                const monthStart = moment().subtract(Number(type), 'months').toDate();
                setStartDate(monthStart);
                setEndDate(current);
            }
        }
        if (!first) setSearchPage(0);
        setFirst(false);
    };

    return (
        <div className="table-input table-style1 // con-mt1">
            <table>
                <colgroup>
                    <col style={{ width: '121px' }} />
                    <col style={{ width: '310px' }} />
                    <col style={{ width: '121px' }} />
                    <col />
                </colgroup>
                <tbody>
                    <tr className="row-gap1">
                        <th scope="row">진행 상태</th>
                        <td className="chk-gap2">
                            {nickPublishStateArr.map((item, idx) => {
                                return (
                                    <InputChk
                                        key={item.label}
                                        type="checkbox"
                                        forId={`filterChk3-${idx + 1}`}
                                        onChange={() => handleCheckPublishState(item.value)}
                                        checked={
                                            item.value == 0
                                                ? publishState.length ===
                                                  nickPublishStateArr.length - 1
                                                : publishState.includes(item.value)
                                        }
                                    >
                                        <span className="txt">{item.label}</span>
                                    </InputChk>
                                );
                            })}
                            {/* <InputChk type="checkbox" forId="filterChk3-2">
                                <span className="txt">진행중</span>
                            </InputChk>
                            <InputChk type="checkbox" forId="filterChk3-3">
                                <span className="txt">종료</span>
                            </InputChk> */}
                        </td>
                        <th scope="row">발행일</th>
                        <td colSpan={3}>
                            <div className="datepicker-period">
                                <div className="datepicker">
                                    <DatePicker
                                        placeholderText={'시작 일 선택'}
                                        selectsStart
                                        date={startDate!}
                                        maxDate={endDate}
                                        changed_date={(date: Date) => onDateChange(date, 's')}
                                    />
                                </div>
                                <span className="ico">~</span>
                                <div className="datepicker">
                                    <DatePicker
                                        placeholderText={'종료 일 선택'}
                                        selectsEnd
                                        date={endDate!}
                                        minDate={startDate ? startDate : currDate}
                                        maxDate={new Date('9999-12-31')}
                                        changed_date={(date: Date) => onDateChange(date, 'e')}
                                    />
                                </div>
                            </div>
                            <TabMenu
                                tabType={2}
                                tabItems={[
                                    { tabName: '1주', value: '7' },
                                    { tabName: '1개월', value: '1' },
                                    { tabName: '3개월', value: '3' },
                                    // { tabName: '전체', value: '0' },
                                ]}
                                selected={dateTab}
                                className="tab-size2"
                                onChange={(value: string) => onDateButton(value)}
                                reset={true}
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
